import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { useInvoicingConnectionStatus, INVOICING_STATUS_CONNECTED } from '../../hooks/useInvoicing';
import { INVOICING } from '../../constants/auth';
import InvoicingClientsSkeleton from '../../viewsv2/Invoicing/Clients/skeleton';

type InvoicingGuardProps = {
  children: React.ReactNode;
};

const InvoicingGuard = ({ children }: InvoicingGuardProps) => {
  const selectedCompany = useAppSelector((state) => state.companyUser.companyUser?.selectedCompany);
  const isEnabled = selectedCompany?.productStatus.readyForInvoicing;

  const { data: connection, isLoading: isLoadingConnection } = useInvoicingConnectionStatus(
    isEnabled ? selectedCompany?.id : undefined
  );

  if (!selectedCompany || (isEnabled && isLoadingConnection)) {
    return <InvoicingClientsSkeleton />;
  }

  if (!isEnabled || connection?.status !== INVOICING_STATUS_CONNECTED) {
    return <Navigate to={INVOICING} replace />;
  }

  return <>{children}</>;
};

export default InvoicingGuard;
